export default __webpack_public_path__ + "static/media/bank_cards.f48a950a.svg";